import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import IAddEditWeekendHolidays from '../../../models/forms/IAddEditWeekendHoliday';
import { formatMessage } from '../../../translations/format-message';
import AddEditWeekendForm from '../forms/add-weekend-form';
import './add-holiday-calendar.css';

interface IProps {
  selctedYear: number;
}

const AddEditWeekend = (props: IProps) => {
  const { processStore, factoryScheduleStore } = useStore();
  const { resetAddUpdateProcessState, resetProcessDetail } = processStore;

  const {
    AddFactoryWeekendService,
    addEditFactoryWeekendState,
    WeekendSchedule,
  } = factoryScheduleStore;

  const initialValues: IAddEditWeekendHolidays = WeekendSchedule;

  useEffect(() => {
    if (addEditFactoryWeekendState.error) {
      toast.error(formatMessage(addEditFactoryWeekendState.error));
      resetAddUpdateProcessState();
    }
  }, [addEditFactoryWeekendState.error]);

  const onSubmitForm = ({
    Weekend_1,
    Weekend_2,
    Comment,
  }: IAddEditWeekendHolidays) => {
    var addObj: IAddEditWeekendHolidays = {
      TenantId: Number(getTenantIdFromLocalStorage()),
      Year: props.selctedYear,
      Weekend_1: Number(Weekend_1),
      Weekend_2: Number(Weekend_2),
      Comment,
    };

    AddFactoryWeekendService(addObj);
  };

  const onModalClosed = () => {
    resetProcessDetail();
  };

  return (
    <React.Fragment>
      <AddEditWeekendForm
        initialValues={initialValues}
        id={0}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        isLoading={addEditFactoryWeekendState.inProgress}
        selectedYear={props.selctedYear}
      />
    </React.Fragment>
  );
};

export default AddEditWeekend;
